"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editorReducer = exports.editorState = void 0;

var _immer = _interopRequireDefault(require("immer"));

var editorState = {
  site: null,
  post: null,
  siteHasChanged: false,
  postHasChanged: false
};
exports.editorState = editorState;

var editorReducer = function editorReducer(state, action) {
  var payload = action.payload;
  return (0, _immer.default)(state, function (draft) {
    switch (action.type) {
      /******************************
       * Sites
       ******************************/
      case "ADD_EDITOR_SITE":
        draft.site = payload;
        draft.siteHasChanged = false;
        break;

      case "UPDATE_EDITOR_SITE":
        draft.site = payload;
        draft.siteHasChanged = true;
        break;

      /******************************
       * Collections
       ******************************/

      case "UPDATE_EDITOR_COLLECTION":
        draft.site.postTypes[payload.id] = payload;
        break;

      /******************************
       * Posts
       ******************************/

      case "ADD_EDITOR_POST":
        draft.post = payload;
        draft.postHasChanged = false;
        break;

      case "UPDATE_EDITOR_POST":
        draft.post = payload;
        draft.postHasChanged = true;
        break;

      /******************************
       * General Settings
       ******************************/

      case "CLEAR_EDITOR":
        draft.site = null;
        draft.siteHasChanged = false;
        draft.post = null;
        draft.postHasChanged = false;
        break;

      default:
    }
  });
};

exports.editorReducer = editorReducer;